(function () {
  'use strict';

  /* ── Slider ─────────────────────────────────────────────── */
  function initSlider(gallery) {
    var inner  = gallery.querySelector('.jp2-slider-inner');
    var slides = gallery.querySelectorAll('.jp2-slide');
    var dots   = gallery.querySelectorAll('.jp2-dot');
    var thumbs = gallery.querySelectorAll('.jp2-thumb');

    if (!inner || slides.length <= 1) return;

    var current   = 0;
    var startX    = 0;
    var dragDelta = 0;
    var dragging  = false;

    function goTo(index) {
      index = Math.max(0, Math.min(slides.length - 1, index));
      current = index;
      inner.style.transform = 'translateX(-' + (index * 100) + '%)';

      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === index);
      });
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === index);
        if (i === index) {
          t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
        }
      });
    }

    /* Dot clicks */
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.index, 10));
      });
    });

    /* Thumbnail clicks */
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        goTo(parseInt(thumb.dataset.index, 10));
      });
    });

    /* Touch swipe */
    inner.addEventListener('touchstart', function (e) {
      startX    = e.touches[0].clientX;
      dragDelta = 0;
      dragging  = true;
    }, { passive: true });

    inner.addEventListener('touchmove', function (e) {
      if (dragging) dragDelta = e.touches[0].clientX - startX;
    }, { passive: true });

    inner.addEventListener('touchend', function () {
      if (!dragging) return;
      dragging = false;
      if (dragDelta < -50)      goTo(current + 1);
      else if (dragDelta > 50)  goTo(current - 1);
    });

    /* Mouse drag */
    inner.addEventListener('mousedown', function (e) {
      startX    = e.clientX;
      dragDelta = 0;
      dragging  = true;
      e.preventDefault();
    });

    document.addEventListener('mousemove', function (e) {
      if (dragging) dragDelta = e.clientX - startX;
    });

    document.addEventListener('mouseup', function () {
      if (!dragging) return;
      dragging = false;
      if (dragDelta < -50)      goTo(current + 1);
      else if (dragDelta > 50)  goTo(current - 1);
    });

    /* Keyboard */
    gallery.setAttribute('tabindex', '0');
    gallery.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
    });

    goTo(0);
  }

  /* ── Popups ─────────────────────────────────────────────── */
  function initPopups() {
    var lastFocused = null;

    function openPopup(id) {
      var overlay = document.getElementById(id);
      if (!overlay) return;
      lastFocused = document.activeElement;
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var closeBtn = overlay.querySelector('.jp2-popup-close');
      if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 50);
    }

    function closePopup(overlay) {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocused) lastFocused.focus();
    }

    document.querySelectorAll('[data-jp2-popup]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        openPopup(trigger.dataset.jp2Popup);
      });
    });

    document.querySelectorAll('.jp2-popup-overlay').forEach(function (overlay) {
      var closeBtn = overlay.querySelector('.jp2-popup-close');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () { closePopup(overlay); });
      }
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) closePopup(overlay);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.jp2-popup-overlay.is-open').forEach(function (ov) {
          closePopup(ov);
        });
      }
    });
  }

  /* ── Buy Now ────────────────────────────────────────────── */
  function initBuyNow() {
    document.querySelectorAll('.jp2-buy-now').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        /* If a bundle is on the page, Buy Now should check out the
           currently selected bundle (tier + chosen flavors), not a lone
           unit of the base variant — otherwise a customer who picked
           "Buy 3" and chose flavors would land at checkout with just 1 item. */
        var bundlePicker = document.querySelector('bundle-picker');
        var items = null;
        if (bundlePicker && typeof bundlePicker.getItems === 'function') {
          var bundleItems = bundlePicker.getItems();
          if (bundleItems.length) items = bundleItems;
        }

        if (!items) {
          /* Resolve current variant ID */
          var variantId = null;

          /* 1. Try the variant picker's JSON script tag (most reliable) */
          var variantScript = document.querySelector('[data-selected-variant]');
          if (variantScript) {
            try {
              var variant = JSON.parse(variantScript.textContent);
              if (variant) variantId = variant.id;
            } catch (_) {}
          }

          /* 2. Fallback: read the hidden form input */
          if (!variantId) {
            var hiddenInput = document.querySelector('[data-type="add-to-cart-form"] input[name="id"]');
            if (hiddenInput) variantId = hiddenInput.value;
          }

          if (!variantId) return;
          items = [{ id: parseInt(variantId, 10), quantity: 1 }];
        }

        var originalText   = btn.textContent;
        btn.textContent    = 'Processing…';
        btn.disabled       = true;

        waitForGoKwikSdk().then(function () {
          if (typeof window.onBuyNowClick === 'function') {
            /* GoKwik's own buy-now API: checks out exactly this items list on
               its own, independent of the persistent Shopify cart — unlike
               sdk.initCheckout(), it does NOT pull in anything already sitting
               in the cart from a prior "Add Bundle to Cart" click. */
            window.onBuyNowClick(e, false, items.map(function (item) {
              return { id: String(item.id), quantity: item.quantity };
            }));
            btn.textContent = originalText;
            btn.disabled    = false;
            return;
          }

          /* Fallback for when GoKwik never loaded: this does add to the real
             cart (so, unlike above, existing cart items would come along),
             but it's the only way left to reach checkout at all. */
          fetch('/cart/add.js', {
            method:  'POST',
            headers: {
              'Content-Type':    'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ items: items })
          })
            .then(function () {
              window.location.href = '/checkout';
            })
            .catch(function () {
              btn.textContent = originalText;
              btn.disabled    = false;
            });
        });
      });
    });
  }

  /* Mirrors gokwik.liquid's own waitForGoKwik() — that copy is private to its
     IIFE, so Buy Now (which needs to hand off to the SDK after adding a
     bundle to cart) waits on the same window.gokwikSdk / "gokwikLoaded" event
     independently. */
  function waitForGoKwikSdk() {
    return new Promise(function (resolve) {
      if (window.gokwikSdk) return resolve(window.gokwikSdk);
      var done = false;
      function onReady() {
        if (done) return;
        done = true;
        window.removeEventListener('gokwikLoaded', onReady);
        resolve(window.gokwikSdk || null);
      }
      window.addEventListener('gokwikLoaded', onReady);
      setTimeout(function () {
        if (done) return;
        done = true;
        window.removeEventListener('gokwikLoaded', onReady);
        resolve(window.gokwikSdk || null);
      }, 3000);
    });
  }

  /* ── Add to Cart (bundle-aware) ────────────────────────────
     When a bundle is on the page, "Add to cart" must submit the selected
     bundle (tier + chosen flavors), not the plain single default variant
     Dawn's <product-form> would otherwise submit. A capture-phase listener
     on <product-form> runs before its own bubble-phase submit handler
     (attached directly to the inner <form>), so it can intercept first. */
  function initBundleAwareAddToCart() {
    document.querySelectorAll('product-form').forEach(function (productFormEl) {
      productFormEl.addEventListener('submit', function (e) {
        var bundlePicker = document.querySelector('bundle-picker');
        if (!bundlePicker || typeof bundlePicker.addBundleToCart !== 'function') return;

        var bundleItems = typeof bundlePicker.getItems === 'function' ? bundlePicker.getItems() : [];
        if (!bundleItems.length) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        var addToCartBtn = productFormEl.querySelector('.jp2-add-to-cart');
        bundlePicker.addBundleToCart(addToCartBtn);
      }, true);
    });
  }

  /* ── Quick nav (Offers / FAQs / Reviews) ──────────────────── */
  function initQuickNav() {
    var targetFinders = {
      offers: function () { return document.querySelector('bundle-picker'); },
      faqs: function () { return document.querySelector('.jp2-popup-buttons'); },
      reviews: function () { return document.querySelector('.jp-testimonials'); }
    };

    document.querySelectorAll('[data-jp2-scroll-target]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var findTarget = targetFinders[btn.dataset.jp2ScrollTarget];
        var target = findTarget && findTarget();
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ── Bootstrap ──────────────────────────────────────────── */
  function init() {
    document.querySelectorAll('.jp2-gallery').forEach(initSlider);
    initPopups();
    initBuyNow();
    initBundleAwareAddToCart();
    initQuickNav();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-init when Theme Editor reloads the section */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.jp2-gallery').forEach(initSlider);
    initPopups();
    initBuyNow();
    initBundleAwareAddToCart();
    initQuickNav();
  });
})();
